import { styles as commonStyles } from '../../../base/styles/common.scss';
import { styles as styleHelpersStyles } from '../../../../../assets/style-helpers.scss';
import { styles } from './template.scss';
export const templateAtlassianJiraConfluenceSensor = document.createElement('template');

templateAtlassianJiraConfluenceSensor.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <style>${styleHelpersStyles}</style>
  <gz-title fontSize="18" fontWeight="500" id="jira-confluence-title"/></gz-title>
  <div class="form-wrapper" id="integration-types" class="sensor-wrapper">
      <gz-form-field class="jira-confluence-sensors" label="" id="jira_checkbox" required stacked>
        <gz-checkbox gz-form-input class="jira" ></gz-checkbox>
      </gz-form-field>
      <gz-form-field class="jira-confluence-sensors" label="" id="confluence_checkbox" required stacked>
        <gz-checkbox gz-form-input class="confluence" ></gz-checkbox>
      </gz-form-field>
    <div class="sensor-data">
      <div class="sensor-data-list">
        <gz-form-field label="" id="organization-site-domain" required stacked>
        <gz-input gz-form-input="" type="text" ></gz-input>
        <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field label="" id="product-admin-email" required stacked>
        <gz-input gz-form-input="" type="text" ></gz-input>
        <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field label="" id="product-admin-api-token" required stacked>
        <gz-input gz-form-input="" type="password" ></gz-input>
        <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>
    </div>
    <gz-button id="add-to-list">
    </gz-button>
    <gz-integration-atlassian-jira-confluence-grid>
    </gz-integration-atlassian-jira-confluence-grid>
  </div>
`;
